module.exports = __webpack_public_path__ + "static/media/search.b3bc916f.svg";